export default {
  name: 'manifest',
  signature: '[COMMAND]',
  isGroupRoot: true,
  description: 'Interacts with the studio configuration.',
}
